const SalesVelocitySettingsType = {
    purchasing: 'purchasing',
    restockAMZ: 'restockAMZ',
    warehouse: 'warehouse'
};

module.exports = Object.freeze(SalesVelocitySettingsType);